module.exports = "/_next/static/images/510ff9b1b529415712483ce6732fe389-money.svg.webp";